import { Link } from 'react-router-dom';
import Button from '@components/Button';
import HomeIntro from '@components/HomeIntro';
import GradientDivider from '@components/GradientDivider';
import {
  WindIcon,
  LineChartIcon,
  GlobeIcon,
  SettingsIcon,
  SparklesIcon,
  BellIcon,
} from '@components/Icons';

function Home() {
  return (
    <>
      <div className="relative left-1/2 right-1/2 w-screen -translate-x-1/2 overflow-hidden">
        <img
          src="/pictures/header-home-2.jpg"
          alt="Xhalin breathing"
          className="h-64 w-full object-cover md:h-80 lg:h-96"
        />
      </div>
      <div className="animate-fade-in py-12">
        {/* Hero Section */}
        <section className="mb-16 text-center">
          <h1 className="gradient-text mb-4 pb-6 text-4xl font-bold">
            Breathe like the Brave.
          </h1>
          <p className="mx-auto mb-4 max-w-2xl text-xl text-gray-600">
            Elite performers, from Navy SEALs to pro athletes — use controlled
            breathing to stay sharp under pressure.{' '}
            <span className="logo-font font-bold">Xhalin</span> brings that same
            focus into your daily life.
          </p>
          <p className="mx-auto mb-4 max-w-2xl text-xl text-gray-600">
            Steady your breath, steady your mind, and meet stress with clarity
            instead of chaos.
          </p>
          <p className="mx-auto mb-8 max-w-2xl text-xl font-semibold text-gray-600">
            Control the breath — control the moment.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {/* Start Breathing button moved to CTA section */}
          </div>
          <GradientDivider />
        </section>

        {/* Features Grid */}
        <HomeIntro />

        <section className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <WindIcon className="h-5 w-5 text-gray-700" />
              Guided Breathing
            </h3>
            <p className="text-gray-600">
              Follow a structured breathing rhythm with visual guidance and
              gentle audio cues to help you stay focused and present.{' '}
            </p>
          </div>

          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <LineChartIcon className="h-5 w-5 text-gray-700" />
              Progress Tracker
            </h3>
            <p className="text-gray-600">
              Save and monitor all your breathing sessions to see your growth
              over time.
            </p>
          </div>

          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <GlobeIcon className="h-5 w-5 text-gray-700" />
              Global Leaderboard
            </h3>
            <p className="text-gray-600">
              Compare your practice time with the global community and stay
              motivated.
            </p>
          </div>

          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <SettingsIcon className="h-5 w-5 text-gray-700" />
              Personalization
            </h3>
            <p className="text-gray-600">
              Make the experience yours by choosing your preferred breathing
              ratios, visuals, sounds, and session settings.{' '}
            </p>
          </div>

          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <SparklesIcon className="h-5 w-5 text-gray-700" />
              Affirmations
            </h3>
            <p className="text-gray-600">
              Receive gentle, positive affirmations before and after each
              session to support calm, confidence, and inner balance.
            </p>
          </div>

          <div className="card">
            <h3 className="mb-2 flex items-center gap-2 text-xl font-semibold">
              <BellIcon className="h-5 w-5 text-gray-700" />
              Daily Reminders
            </h3>
            <p className="text-gray-600">
              Set up recurring reminders to build a consistent breathwork habit.
            </p>
          </div>
        </section>

        {/* CTA Section */}
        <section className="mt-16 text-center">
          <GradientDivider />

          <div className="card mx-auto max-w-2xl">
            <h2 className="mb-4 text-3xl font-bold">Ready to begin?</h2>
            <p className="mb-6 text-gray-600">
              Join thousands of practitioners transforming stress into clarity —
              one breath at a time.
            </p>
            <div className="mt-4">
              <Link to="/dashboard">
                <Button
                  variant="primary"
                  size="lg"
                  className="begin-breathing-button"
                >
                  Begin your breathing practice
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
